export const APP_NAME = 'Shipbase';
export const APP_DESCRIPTION = 'The operating system for your supply chain.';
